<sbb-form-field
  [label]="'app.view.dialogs.note-dialog.note-form.title' | translate"
  class="sbb-form-field-long"
>
  <input
    type="text"
    sbbInput
    cdkFocusInitial
    [formControl]="model.getControl('noteTitle')"
    (focusout)="onUpdate()"
    (keydown)="onKeydown($event)"
    [placeholder]="'app.view.dialogs.note-dialog.note-form.name' | translate"
  />
</sbb-form-field>
